import React, {useState} from 'react';
import classnames from 'classnames';
import PopupExternalLinks from '../PopupExternalLinks';
import NavLinkButton from '../NavLinkButton';
import ModalCommon from "../ModalCommon";
import accountSideBar from 'common/assets/account_side_menu.svg';
import web from 'common/assets/web-24px.svg';
import addBusiness from 'common/assets/add_business-24px.svg';
import addBusinessActive from 'common/assets/add_business-active.svg';
import listAlt from 'common/assets/list_alt-24px.svg';
import listAltActive from 'common/assets/list_alt-active.svg';
import assets from 'common/assets/assets_db.svg';
import assetsActive from 'common/assets/assets_db-active.svg';
import assets84 from 'common/assets/share-hands.svg';
import assets84Active from 'common/assets/share-hands-active.svg';
import externalLinks from 'common/assets/link_black_24dp.svg';
import externalLinksActive from 'common/assets/link_black_24dp-active.svg';
import download from 'common/assets/download-24px-sidebar.svg';
import downloadActive from 'common/assets/download-24px-sidebar.svg';
import {getFileMonitorInstaller} from '../../actions/files/getFileMonitorInstaller';
import {downloadFile} from '../../utils/files/downloadFile';
import AnimatedProgress from '../AnimatedProgress';
import {getFullDataURI} from '../../utils/files/getFullDataURI';
import {pathnames as P} from '../../constants/pathnames';
import styles from './styles.module.scss';

const SideBar = ({
                   name,
                   family_name,
                   email,
                   rollUpSideBar,
                   allowInspectionsShare,
                   firmInspectionsAccess
                 }) => {
  const disableEstimatesRepo = !allowInspectionsShare || !firmInspectionsAccess;
  const disableEstimatesDatabase = !firmInspectionsAccess;

  const [loading, setLoading] = useState(false);
  const downloadFileMonitorInstaller = async () => {
    try {
      setLoading(true);
      const body = await getFileMonitorInstaller();
      const dataURI = getFullDataURI({body, file_extension: 'msi'});
      console.log(dataURI.slice(0, 100) + '...');
      downloadFile(dataURI, 'FileMonitorInstaller.msi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={rollUpSideBar ? styles.sideBarShow : styles.sideBarRollUp}>
      <div
        className={rollUpSideBar ? styles.userInfoShow : styles.userInfoHide}
      >
        <img src={accountSideBar} alt="accountSideBar"/>
        <h2>{name} {family_name}</h2>
        <p>{email}</p>
      </div>
      <div className={styles.content}>
        <div className={rollUpSideBar ? styles.menuShow : styles.menuRollUp}>
          <NavLinkButton
            to={P.MAIN_MENU}
            className={rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp}
          >
            <img className={styles.navLinkImage} src={web} alt="web"/>
            {rollUpSideBar &&
              <p className={styles.navLinkTitle}>חזרה לדף הבית</p>}
          </NavLinkButton>
          <NavLinkButton
            to={P.TASKS}
            className={rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp}
            activeClassName={rollUpSideBar ? styles.navLinkActiveShow : styles.navLinkActiveRollUp}
          >
            <img className={styles.navLinkImage} src={addBusiness}
                 alt="add-business"/>
            <img className={styles.navLinkImageActive} src={addBusinessActive}
                 alt="add-business"/>
            {rollUpSideBar &&
              <p className={styles.navLinkTitle}>המשימות שלי</p>}
          </NavLinkButton>
          <NavLinkButton
            to={P.INSPECTED_LIST}
            className={rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp}
            activeClassName={rollUpSideBar ? styles.navLinkActiveShow : styles.navLinkActiveRollUp}
          >
            <img className={styles.navLinkImage} src={listAlt} alt="list-alt"/>
            <img className={styles.navLinkImageActive} src={listAltActive}
                 alt="list-alt"/>
            {rollUpSideBar &&
              <p className={styles.navLinkTitle}>מאגר הדוחות שלי</p>}
          </NavLinkButton>
          <NavLinkButton
            to={P.ESTIMATES_DATABASE}
            className={styles.textDecorationNone}
            activeClassName={rollUpSideBar ? styles.navLinkActiveShow : styles.navLinkActiveRollUp}
            disabled={disableEstimatesDatabase}
            onClick={e => {
              if (disableEstimatesDatabase) {
                e.preventDefault();
              }
            }}
          >
            <div
              className={classnames(
                rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp,
                {[styles.disabledLink]: disableEstimatesDatabase}
              )}
            >
              <img className={styles.navLinkImage} src={assets} alt="assets"/>
              <img className={styles.navLinkImageActive} src={assetsActive} alt="assets"/>
              {rollUpSideBar && <p className={styles.navLinkTitle}>מאגר דוחות המשרד</p>}
            </div>
          </NavLinkButton>
          <NavLinkButton
            to={P.ESTIMATES_REPOSITORY}
            className={styles.textDecorationNone}
            activeClassName={(rollUpSideBar) ? styles.navLinkActiveShow : styles.navLinkActiveRollUp}
            disabled={disableEstimatesRepo}
            onClick={e => {
              if (disableEstimatesRepo) {
                e.preventDefault();
              }
            }}
          >
            <div
              className={classnames(
                rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp,
                {[styles.disabledLink]: disableEstimatesRepo}
              )}
            >
              <img className={styles.navLinkImage} src={assets84} alt="assets84"/>
              <img className={styles.navLinkImageActive} src={assets84Active} alt="assets84Active"/>
              {rollUpSideBar && <p className={styles.navLinkTitle}>מאגר מידע שיתופי</p>}
            </div>
          </NavLinkButton>
          <ModalCommon
            customModalTrigger={
              <div className={rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp}>
                <img
                  className={styles.navLinkImage}
                  src={externalLinks} alt="i"
                />
                <img
                  className={styles.navLinkImageActive}
                  src={externalLinksActive} alt="i"
                />
                {rollUpSideBar && <p className={styles.navLinkTitle}>לינקים שימושיים</p>}
              </div>
            }
          >
            <PopupExternalLinks />
          </ModalCommon>
          <div
            download
            className={classnames(styles.textDecorationNone)}
            onClick={downloadFileMonitorInstaller}
          >
            <div
              className={classnames(
                rollUpSideBar ? styles.navLinkShow : styles.navLinkRollUp
              )}
            >
              <img className={styles.navLinkImage} src={download} alt="download"/>
              <img className={styles.navLinkImageActive} src={downloadActive} alt="downloadActive"/>
              {rollUpSideBar && (
                <p className={styles.navLinkTitle}>
                  סנכרון קבצים
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      {loading && <div className={styles.progress}><AnimatedProgress/></div>}
    </div>
  );
};

export default SideBar;